import { render, staticRenderFns } from "./amlkyc.vue?vue&type=template&id=4c101b62&scoped=true&"
import script from "./amlkyc.vue?vue&type=script&lang=js&"
export * from "./amlkyc.vue?vue&type=script&lang=js&"
import style0 from "./amlkyc.vue?vue&type=style&index=0&id=4c101b62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c101b62",
  null
  
)

export default component.exports